<!--New Slider For HomePage-->
<div class="uk-position-relative uk-visible-toggle uk-light home-page-slider" tabindex="-1" uk-slider="autoplay:true; autoplay-interval:4000">

  <ul class="uk-slider-items uk-child-width-1-1" *ngIf="banners">

    <li *ngFor="let banner of banners">
      <a
        href="{{banner.banner_url}}">
        <picture>
          <source media="(max-width:767px)" srcset="{{banner.banner_file_mobile}}">
          <source media="(min-width:768px) and (max-width:1024px)"
                  srcset="{{banner.banner_file_tab}}">
          <img src="{{banner.banner_file_desktop}}" alt="">
        </picture>
      </a>
    </li>

  </ul>

  <a class="uk-position-center-left uk-position-small" href="#" uk-slidenav-previous uk-slider-item="previous"></a>
  <a class="uk-position-center-right uk-position-small" href="#" uk-slidenav-next uk-slider-item="next"></a>

</div>

<!--VIDEO SLIDER--->
<div uk-slideshow="ratio: false;animation: push" class="uk-position-relative" hidden>
  <div class="uk-position-relative uk-visible-toggle uk-light video-img-slider uk-dark" tabindex="-1">
    <ul class="uk-slideshow-items" uk-height-viewport="offset-bottom: 30">
      <li>
        <div class="video-thumbnail position-relative">
          <div class="{{selectedCity.toLowerCase() == 'mumbai'?'video-poster':'video-poster-pune' }}">
            <div class="video-hightlight">
              <div class="logo-big mb-6">
                <img src="assets/images/logo-big.png" alt="">
              </div>
              <div class="details">
                <p>Experiences beyond imagination</p>
                <h4>Curated Just For You</h4>
                <!-- <h6>Start your experience journey</h6> -->
              </div>
              <div class="play-btn mt-3" (click)="playMasterVideo($event.target)">
                <img src="assets/images/icons/play-2.png" alt="" class="play playVideo cursor-pointer">
              </div>
            </div>
          </div>
          <div class="video-stream">
            <video width="100%" height="100%" src="https://api.things2.do/uploads/intro.mp4" controls playsinline
                   *ngIf="appService.isDesktopDevice"></video>
            <video width="100%" height="100%" src="assets/small-Website-intro-video-9-16.mp4" controls playsinline
                   *ngIf="appService.isMobile"></video>
          </div>
        </div>
      </li>
      <li>
        <img src="assets/images/valentine-banner/main-web-banner-1920x1080.webp" alt="Valentine day" class="full-img">
      </li>
      <li>
        <video src="https://api.things2.do/uploads/intro.mp4" autoplay loop muted playsinline uk-cover></video>
      </li>
    </ul>

    <a class="uk-position-center-left custom-nav" href="#" uk-slidenav-previous uk-slideshow-item="previous">
      <img src="assets/images/icons/slider-arrow-left.png" alt="">
    </a>
    <a class="uk-position-center-right custom-nav" href="#" uk-slidenav-next uk-slideshow-item="next">
      <img src="assets/images/icons/slider-arrow-left.png" alt="">
    </a>

  </div>

  <!-- <div class="scroll-down">
      <div class="line-vertical"></div>
  </div> -->

</div>
